import type {
  ImageLibraryFeatureFlags,
  ImageLibraryNavigationItem,
  ImageLibraryStep,
} from 'hb-react/backoffice/components/ImageLibrary/types';

export const getNavigationItems = ({
  features,
  step,
}: {
  features: ImageLibraryFeatureFlags;
  step: ImageLibraryStep;
}): ImageLibraryNavigationItem[] | undefined => {
  if (step === 'set') {
    return [
      features.upload && {
        icon: (
          <svg
            width="24"
            height="24"
            viewBox="0 0 30 30"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g fill="none" fillRule="evenodd">
              <path d="M0 0h30v30H0z" />
              <path d="M5 5h20v20H5z" />
              <path
                d="M6 16v6c0 1.1045695.8954305 2 2 2h14c1.1045695 0 2-.8954305 2-2v-6h0"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <g
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              >
                <path d="M14.99999954 17V6L11.000295 10.02188549M15.000295 17V6l3.99970454 4.02188549" />
              </g>
            </g>
          </svg>
        ),
        id: 'upload',
        title: s__('ImageLibrary|Upload'),
      },
      features.url && {
        icon: (
          <svg
            width="24"
            height="24"
            viewBox="0 0 30 30"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g fill="none" fillRule="evenodd">
              <path d="M0 0h30v30H0z" />
              <path d="M5 5h20v20H5z" />
              <g
                transform="translate(5 9.5)"
                fill="currentColor"
                fillRule="nonzero"
              >
                <path d="M5.47369385 8.98233174c-2.02322771 0-3.64996909-1.75299314-3.44853873-3.83075671.17465797-1.80797396 1.79629984-3.13390677 3.60662332-3.13390677h2.36361952C8.55124376 2.01766826 9 1.56503545 9 1.00883413 9 .45135418 8.55124376 0 7.99539796 0H5.47369385C2.21893623 0-.38308505 2.87051029.04654805 6.22434035.4009635 8.99639661 2.8869711 11 5.67384935 11h2.32154862C8.55124376 11 9 10.5486458 9 9.99116587c0-.55620132-.44875624-1.00883413-1.00460204-1.00883413H5.47369385zM12.0058726 0C11.4513041 0 11 .4525802 11 1.00871688c0 .55741515.4513041 1.00871687 1.0058726 1.00871687h2.5216934c2.024494 0 3.6486787 1.75534635 3.4459744 3.83158996-.1759321 1.80776383-1.7962922 3.13226406-3.6091578 3.13226406h-2.35851C11.4513041 8.98128777 11 9.43386797 11 9.99000465 11 10.5474198 11.4513041 11 12.0058726 11h2.3215388c2.7855915 0 5.2715885-2.004649 5.6260025-4.7751046C20.3830452 2.87017666 17.7835847 0 14.527566 0h-2.5216934z" />
                <rect x="6" y="4.5" width="8" height="2" rx="1" />
              </g>
            </g>
          </svg>
        ),
        id: 'url',
        title: s__('ImageLibrary|URL'),
      },
      features.unsplash && {
        icon: (
          <svg
            width="24"
            height="24"
            viewBox="0 0 30 30"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g fill="none" fillRule="evenodd">
              <path d="M0 0h30v30H0z" />
              <path d="M5 5h20v20H5z" />
              <path
                fill="currentColor"
                d="M5 14.0036983h6V19l7.9986988.0071598v-5.0034615H25V25H5zM11.0008109 5v6h8.0024075V5z"
              />
            </g>
          </svg>
        ),
        id: 'unsplash',
        title: s__('ImageLibrary|Unsplash library'),
      },
    ].filter(Boolean);
  }

  if (step === 'crop') {
    return [
      features.cropAndZoom && {
        icon: (
          <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" fillRule="evenodd">
              <path d="M0 0h20v20H0z" />
              <path
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M7 1H1v6M19 7V1h-6M7 19H1v-6M19 13v6h-6"
              />
            </g>
          </svg>
        ),
        id: 'crop',
        title: s__('ImageLibrary|Crop and Zoom'),
      },
    ].filter(Boolean);
  }
};
